import apolloClient from '../../utils/apollo-client';
import { clearApplication as mutation } from '../graphql/application';

export default async function () {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation
    })
  );
  return response.data.clearApplication;
}
